import React, { useEffect } from "react";
import Animated, {
  Easing,
  interpolate,
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from "react-native-reanimated";
import { palette, spacing } from "../styles";
import Block from "./Block";

type Props = {
  height?: number;
  width?: number;
  borderRadius?: number;
  backgroundColor?: string;
  marginVertical?: number;
  marginBottom?: number;
  marginTop?: number;
};

const LinePlaceholder = ({
  height = 10,
  width = 10,
  borderRadius = 4.5,
  backgroundColor = palette.common.disabled,
  marginVertical = 0,
  marginBottom = 0,
  marginTop = 0,
}: Props) => {
  const pulse = useSharedValue(0);

  useEffect(() => {
    pulse.value = 0;
    pulse.value = withRepeat(withTiming(1, { duration: 750, easing: Easing.ease }), -1, true);
  }, [pulse]);

  const animatedStyle = useAnimatedStyle(() => {
    return {
      backgroundColor,
      borderRadius: borderRadius * spacing.unit,
      height: (height - 0.5) * spacing.unit,
      opacity: interpolate(pulse.value, [0, 1], [0.3, 0.5]),
      width: width * spacing.unit,
    };
  });

  return (
    <Block
      height={height}
      marginVertical={marginVertical}
      marginBottom={marginBottom}
      marginTop={marginTop}
    >
      <Animated.View style={animatedStyle} />
    </Block>
  );
};

export default React.memo(LinePlaceholder);
